import { render } from "./ModulosList.vue?vue&type=template&id=00490c10&scoped=true"
import script from "./ModulosList.vue?vue&type=script&lang=js"
export * from "./ModulosList.vue?vue&type=script&lang=js"

import "./ModulosList.vue?vue&type=style&index=0&id=00490c10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00490c10"]])

export default __exports__